import {EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";

export class DietaryIndicatorData extends EntityData<DietaryIndicatorData> {
    @identifier id: number;
    @field code: string;
    @field name: string;

    @transientField get description(): string {
        return this.name + " (" + this.code + ")";
    }
}
